import { RoleService } from "@js/services/RoleService";
import {
  AddressLookupDTO,
  Case,
  CaseClient,
  Deal,
  DealClient,
  DevelopmentInput,
  StreetAddressClient,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { CaseService } from "@js/services/CaseService";
import { ContactDetailsDTO } from "@js/DTO/ContactDetailsDTO.cs";

export class ApplicationDetailsController {
  //Search address
  searchresults: string;
  PostCodeOptions: AddressLookupDTO[] = [];
  searchterm: string;
  searchingForAddress: boolean = false;

  //Case info
  loanCriteria: DevelopmentInput;
  case: Case;
  deal: Deal;
  siteDetails: ContactDetailsDTO;
  accountantDetails: ContactDetailsDTO;
  solicitorDetails: ContactDetailsDTO;

  //Sections
  site: boolean = false;
  accountant: boolean = false;
  solicitors: boolean = false;

  isDeal: boolean = false;

  static $inject = [
    "$rootScope",
    "$routeParams",
    "CaseService",
    "CaseClient",
    "$location",
    "StreetAddressClient",
    "$q",
    "RoleService",
    "DealClient",
  ];

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private caseService: CaseService,
    private caseClient: CaseClient,
    private $location: ng.ILocationService,
    private $streetAddressService: StreetAddressClient,
    protected $q: ng.IQService,
    private roleService: RoleService,
    private dealClient: DealClient,
  ) {
    if (this.$routeParams.dealId) {
      this.isDeal = true;
    }

    if (this.isDeal) {
      this.dealClient.fetch(this.$routeParams.dealId).then((result) => {
        this.deal = result;
        this.siteDetails = this.parseContactDetails(this.deal.siteDetails);
        this.accountantDetails = this.parseContactDetails(this.deal.accountantDetails);
        this.solicitorDetails = this.parseContactDetails(this.deal.solicitorDetails);
      });
    } else {
      this.caseClient.fetch(this.$routeParams.CaseId).then((result) => {
        this.case = result;
        this.siteDetails = this.parseContactDetails(this.case.siteDetails);
        this.accountantDetails = this.parseContactDetails(this.case.accountantDetails);
        this.solicitorDetails = this.parseContactDetails(this.case.solicitorDetails);
      });
    }
  }

  goToCaseDashboard(saveChanges: boolean): void {
    if (saveChanges && !this.roleService.IsLender) {
      this.save().then((response) => {
        (this.$rootScope as any).formSaved = true;
        DealHelper.goToCaseDashboard(this.deal.id, this.deal.productFamily, this.$location);
      });
    } else {
      DealHelper.goToCaseDashboard(this.deal.id, this.deal.productFamily, this.$location);
    }
  }

  goToDealForum(saveChanges: boolean): void {
    if (saveChanges && !this.roleService.IsLender) {
      this.save().then((response) => {
        (this.$rootScope as any).formSaved = true;
        this.isDeal
          ? this.$location.path("/dealforum/" + this.deal.id)
          : this.$location.path("/lending/" + this.case.id);
      });
    } else {
      this.isDeal ? this.$location.path("/dealforum/" + this.deal.id) : this.$location.path("/lending/" + this.case.id);
    }
  }

  expandOrCollapse(value: boolean) {
    this.site = value;
    this.accountant = value;
    this.solicitors = value;
    return value;
  }

  save(): ng.IPromise<number> {
    let defer = this.$q.defer<number>();

    if (this.isDeal) {
      this.deal.siteDetails = JSON.stringify(this.siteDetails);
      this.deal.accountantDetails = JSON.stringify(this.accountantDetails);
      this.deal.solicitorDetails = JSON.stringify(this.solicitorDetails);

      this.dealClient
        .addUpdateReturnOnlyID(this.deal)
        .then((response) => {
          defer.resolve(response as number);
          if (
            this.siteDetails.FirstName != null &&
            this.siteDetails.Email != null &&
            this.siteDetails.Role != null &&
            this.siteDetails.LastName != null &&
            this.solicitorDetails.FirstName != null &&
            this.solicitorDetails.LastName != null &&
            this.solicitorDetails.Email != null &&
            this.accountantDetails.FirstName != null &&
            this.accountantDetails.LastName != null &&
            this.accountantDetails.Email != null
          ) {
            this.caseService.setIsSupplimentInfoFilled(true);
          } else {
            this.caseService.setIsSupplimentInfoFilled(false);
          }
          this.goToDealForum(false);
        })
        .catch((response) => {
          defer.reject(response);
        });
    } else {
      this.case.siteDetails = JSON.stringify(this.siteDetails);
      this.case.accountantDetails = JSON.stringify(this.accountantDetails);
      this.case.solicitorDetails = JSON.stringify(this.solicitorDetails);

      this.caseClient
        .addUpdateReturnOnlyID(this.case)
        .then((response) => {
          defer.resolve(response as number);
          if (
            this.siteDetails.FirstName != null &&
            this.siteDetails.Email != null &&
            this.siteDetails.Role != null &&
            this.siteDetails.LastName != null &&
            this.solicitorDetails.FirstName != null &&
            this.solicitorDetails.LastName != null &&
            this.solicitorDetails.Email != null &&
            this.accountantDetails.FirstName != null &&
            this.accountantDetails.LastName != null &&
            this.accountantDetails.Email != null
          ) {
            this.caseService.setIsSupplimentInfoFilled(true);
          } else {
            this.caseService.setIsSupplimentInfoFilled(false);
          }
          this.goToDealForum(false);
        })
        .catch((response) => {
          defer.reject(response);
        });
    }

    return defer.promise;
  }

  getAddressList(searchTerm: string) {
    let foundMatch = false;

    if (this.PostCodeOptions && this.PostCodeOptions && this.PostCodeOptions.length > 0) {
      let addressLookup = this.PostCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.$streetAddressService.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          this.siteDetails.AddressLine1 = address.addressLine1;
          this.siteDetails.AddressLine2 = address.addressLine2;
          this.siteDetails.AddressLine3 = address.addressLine3;
          this.siteDetails.AddressLine4 = address.addressLine4;
          this.siteDetails.PostCode = address.postCode;

          this.searchterm = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        this.siteDetails.AddressLine1 = addressLookup.addressLine1;
        this.siteDetails.AddressLine2 = addressLookup.addressLine2;
        this.siteDetails.AddressLine3 = addressLookup.addressLine3;
        this.siteDetails.AddressLine4 = addressLookup.addressLine4;
        this.siteDetails.PostCode = addressLookup.postCode;
        this.searchterm = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.PostCodeOptions = [];

      this.$streetAddressService
        .getAddressList(searchTerm)
        .then((response) => {
          this.PostCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  parseContactDetails(contactHistoryJson: string): ContactDetailsDTO {
    return JSON.parse(contactHistoryJson);
  }
}
